/**
 * Splitting a set of row ids into batches the datastore API will accept.
 *
 * The batch endpoints refuse a request carrying more than `batchRowsLimit` rows
 * outright rather than trimming it (design §10), and the limit is a governor
 * value the caller reads at runtime — so the split has to happen client-side,
 * against whatever limit that lookup returned.
 */

/**
 * @param ids the ids to send, in the order the caller wants them sent
 * @param limit rows a single request may carry; a non-positive or non-finite
 *        limit is treated as 1 so a misconfigured governor value cannot turn
 *        into an empty or infinite batching loop
 * @returns batches, each at most `limit` long; empty when there is nothing to send
 */
export function chunkIds(ids: string[], limit: number): string[][] {
  const size = Number.isFinite(limit) ? Math.max(1, Math.floor(limit)) : 1;
  const batches: string[][] = [];
  for (let from = 0; from < ids.length; from += size) {
    batches.push(ids.slice(from, from + size));
  }
  return batches;
}
